import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/fr/fondamentaux')({
  component: Outlet,
})
